import { IconPhoto } from "@tabler/icons-react";
import { DfyOrderType } from "@repo/api/dfy";
import {
  DFY_PACKAGE_CREDITS,
  DFY_PACKAGE_IMAGE_COUNTS,
} from "@repo/api/utils/dfy-billing";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectItemText,
  SelectTrigger,
  SelectValue,
} from "@/lib/components/Select";
import {
  DFY_PACKAGE_CONTENT,
  formatDfyCreditsToPrice,
} from "../dfy-order-form-content";

export default function PackageSelectorCard({
  type,
  onSelect,
}: {
  type: DfyOrderType;
  onSelect: (type: DfyOrderType) => void;
}) {
  return (
    <div className="flex flex-col gap-5 rounded-xl border p-4 sm:flex-row sm:items-center sm:gap-4 sm:pr-6">
      <div className="flex min-w-0 flex-1 items-center gap-3 sm:gap-4">
        <span className="flex size-8 shrink-0 items-center justify-center rounded-md sm:size-10">
          <IconPhoto className="size-5 text-text-primary sm:size-6" />
        </span>
        <div className="flex min-w-0 flex-1 flex-col">
          <span className="font-medium">
            {DFY_PACKAGE_CONTENT.find((option) => option.id === type)?.name}
          </span>
          <span className="text-sm text-text-secondary">
            {DFY_PACKAGE_IMAGE_COUNTS[type]} images included
          </span>
        </div>
      </div>
      <Select
        value={type}
        onValueChange={(value) => onSelect(value as DfyOrderType)}
      >
        <SelectTrigger className="w-full shrink-0 sm:w-44">
          <SelectValue placeholder="Select package" />
        </SelectTrigger>
        <SelectContent align="end" className="min-w-64">
          {DFY_PACKAGE_CONTENT.map((option) => (
            <SelectItem
              key={option.id}
              value={option.id}
              userSetsItemText
              className="gap-4"
            >
              <div className="flex min-w-0 flex-1 flex-col">
                <SelectItemText>
                  <span className="font-medium">{option.name}</span>
                </SelectItemText>
                <span className="text-text-secondary">
                  {DFY_PACKAGE_IMAGE_COUNTS[option.id]} images
                </span>
              </div>
              <span className="shrink-0 font-medium">
                {formatDfyCreditsToPrice(DFY_PACKAGE_CREDITS[option.id])}
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
